import React, { useState } from 'react';
import { Clock, ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SEO } from '../components/SEO';
const articles = [{
  date: 'OCT 2024',
  category: 'INTELLIGENCE',
  title: 'The End of General Purpose AI: Why Vertical Sovereignty Wins',
  excerpt: 'As models grow larger, their utility in specific, high-stakes domains diminishes. The future belongs to specialized, sovereign models.',
  readTime: '5 MIN READ'
}, {
  date: 'SEP 2024',
  category: 'INFRASTRUCTURE',
  title: 'Smart Cities are Dead. Long Live Sentient Environments.',
  excerpt: 'Moving beyond simple sensors to environments that actively adapt to their inhabitants through predictive computation.',
  readTime: '7 MIN READ'
}, {
  date: 'AUG 2024',
  category: 'GEOPOLITICS',
  title: 'The Chip War and the Global South',
  excerpt: 'How emerging nations can navigate the semiconductor blockade through efficient code and novel architectures.',
  readTime: '4 MIN READ'
}];
export function Insights() {
  const [filter, setFilter] = useState('ALL');
  const {
    t,
    language
  } = useLanguage();
  const seoTitles = {
    en: 'Intelligence Logs - AI Insights & Technology Analysis | NEW ASIA TECH',
    id: 'Log Intelijen - Wawasan AI & Analisis Teknologi | NEW ASIA TECH'
  };
  const seoDescriptions = {
    en: 'NEW ASIA TECH intelligence logs: Expert insights on AI, infrastructure, and geopolitics. Analysis of sovereign technology, smart cities, and the future of computing.',
    id: 'Log intelijen NEW ASIA TECH: Wawasan ahli tentang AI, infrastruktur, dan geopolitik. Analisis teknologi berdaulat, kota pintar, dan masa depan komputasi.'
  };
  const seoKeywords = {
    en: 'AI blog, technology insights, sovereign AI analysis, smart city technology, geopolitics technology, AI articles, technology trends, NEW ASIA TECH blog',
    id: 'blog AI, wawasan teknologi, analisis AI berdaulat, teknologi kota pintar, geopolitik teknologi, artikel AI, tren teknologi, blog NEW ASIA TECH'
  };
  const categories = [t('insights.all'), t('insights.intelligence'), t('insights.infrastructure'), t('insights.geopolitics')];
  const filteredArticles = filter === 'ALL' ? articles : articles.filter(a => a.category === filter);
  return <>
      <SEO title={seoTitles[language]} description={seoDescriptions[language]} keywords={seoKeywords[language]} url="/insights" type="website" data-id="element-375" />

      <div className="min-h-screen pt-32 pb-20 px-6" data-id="element-376">
        <div className="max-w-[1800px] mx-auto" data-id="element-377">
          <div className="flex flex-col md:flex-row justify-between items-end mb-16 animate-fade-in-up" data-id="element-378">
            <h1 className="text-5xl md:text-7xl font-display font-bold text-ivory" data-id="element-379">
              {t('insights.title')}
            </h1>

            <nav className="flex space-x-6 mt-8 md:mt-0 border-b border-white/10 pb-2" aria-label="Filter articles" data-id="element-380">
              {['ALL', 'INTELLIGENCE', 'INFRASTRUCTURE', 'GEOPOLITICS'].map((cat, idx) => <button key={cat} onClick={() => setFilter(cat)} className={`text-xs font-mono uppercase tracking-widest pb-2 transition-colors ${filter === cat ? 'text-ai-teal border-b-2 border-ai-teal' : 'text-gray-500 hover:text-ivory'}`} aria-current={filter === cat ? 'page' : undefined} data-id="element-381">
                    {categories[idx]}
                  </button>)}
            </nav>
          </div>

          <div className="space-y-0" data-id="element-382">
            {filteredArticles.map((article, index) => <article key={index} className={`group border-t border-white/10 py-12 hover:bg-white/[0.02] transition-colors cursor-pointer animate-fade-in-up delay-${index * 100}`} data-id="element-383">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-baseline" data-id="element-384">
                  <time className="lg:col-span-2 font-mono text-xs text-graphite group-hover:text-white transition-colors" data-id="element-385">
                    {article.date}
                  </time>
                  <div className="lg:col-span-2 font-mono text-xs text-ai-teal uppercase tracking-widest" data-id="element-386">
                    {article.category}
                  </div>
                  <div className="lg:col-span-5" data-id="element-387">
                    <h2 className="text-2xl md:text-3xl font-display font-bold text-ivory mb-4 group-hover:text-muted-gold transition-colors flex items-center" data-id="element-388">
                      {article.title}
                      <ArrowUpRight className="w-5 h-5 ml-2 opacity-0 group-hover:opacity-100 transition-opacity transform group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-389" />
                    </h2>
                  </div>
                  <div className="lg:col-span-3 flex flex-col justify-between h-full" data-id="element-390">
                    <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-391">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center text-xs font-mono text-graphite" data-id="element-392">
                      <Clock className="w-3 h-3 mr-2" data-id="element-393" />
                      {article.readTime}
                    </div>
                  </div>
                </div>
              </article>)}
            <div className="border-t border-white/10" data-id="element-394" />
          </div>
        </div>
      </div>
    </>;
}